<template>
  <div v-tooltip="getRateQuoteChargeStopTooltip(data)">
    {{ data.stopSequenceNumber ?? '-' }}
  </div>
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';

import { useTooltip } from '@rygen/rygen-ui/composables';
import { renderFullAddress } from '@rygen/rygen-ui/util';

import { RateQuoteCharge } from '@/model';
import { useParentEntityStore } from '@/stores/ParentEntity.ts';

const props = defineProps({
  data: {
    type: Object as PropType<any>,
    default: () => undefined,
  },
});
const { data } = toRefs(props);

const { parentEntity } = useParentEntityStore();
const vTooltip = useTooltip();

const getRateQuoteChargeStopTooltip = (charge: RateQuoteCharge) => {
  const associatedStop = (parentEntity.value?.stops ?? []).find(
    (s) => s.sequenceNumber === charge.stopSequenceNumber,
  );
  const locationName = associatedStop?.location?.locationName ?? '';
  const address =
    renderFullAddress(associatedStop?.location?.toAddress()) ?? '';
  const tooltipValue = `${locationName}\n${address}`.trim();

  return {
    value: tooltipValue,
    disabled: !associatedStop,
  };
};
</script>
